import { render, staticRenderFns } from "./EditDetailFooter.vue?vue&type=template&id=ca995d4e&scoped=true"
import script from "./EditDetailFooter.vue?vue&type=script&lang=js"
export * from "./EditDetailFooter.vue?vue&type=script&lang=js"
import style0 from "./EditDetailFooter.vue?vue&type=style&index=0&id=ca995d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca995d4e",
  null
  
)

export default component.exports